import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { logError } from "@/lib/log";
import { PlanCustomizer } from "@/components/plan/PlanCustomizer";

const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export const NudgeDays = () => {
  const [d, setD] = useState(null);

  useEffect(() => {
    api.get("/insights/weekday-nudge").then((r) => setD(r.data)).catch((e) => logError("Nudge days failed:", e));
  }, []);

  const save = async (days) => {
    const prev = d.days;
    setD((x) => ({ ...x, days }));
    try {
      await api.put("/insights/weekday-nudge", { days });
      toast.success(days.length ? `Nudge on ${days.map((i) => DAYS[i]).join(" & ")}` : "Nudge day set to automatic");
    } catch (e) {
      setD((x) => ({ ...x, days: prev }));
      toast.error(errMsg(e));
    }
  };
  const pick = (i) => {
    if (d.days.includes(i)) return save(d.days.filter((x) => x !== i));
    if (d.days.length >= 2) return toast.error("Pick up to 2 days");
    return save([...d.days, i].sort());
  };

  if (!d) return null;
  const chip = (on) => `mm-chip !py-1.5 !px-3 text-sm ${on ? "mm-chip-on" : ""}`;
  return (
    <div className="mt-4 pt-4 border-t" data-testid="nudge-days">
      <div className="text-sm text-mm-muted mb-2">
        Which day? {d.toughest_day ? <>We noticed <b data-testid="nudge-auto-day">{d.toughest_day}</b> tend to feel heaviest.</> : "We'll pick once there's enough data."}
      </div>
      <div className="flex flex-wrap gap-1.5">
        <button className={chip(!d.days.length)} onClick={() => d.days.length && save([])} data-testid="nudge-day-auto">Automatic</button>
        {DAYS.map((n, i) => <button key={n} className={chip(d.days.includes(i))} onClick={() => pick(i)} data-testid={`nudge-day-${n.toLowerCase()}`}>{n}</button>)}
      </div>
      <div className="text-xs text-mm-muted mt-2">Choose up to 2 days. A day you pick always gets the nudge.</div>
      <div className="flex flex-wrap gap-2 mt-3">
        <Link to="/plan" className="mm-btn-ghost !py-1.5 !px-3 text-sm inline-flex" data-testid="nudge-open-plan">Open today's plan</Link>
        <PlanCustomizer />
      </div>
    </div>
  );
};
